/* Destilo — "You may also like": fetch Shopify recommendations (related),
   render ps-cards, and give them the same add-to-cart behaviour as the showcase. */
(function () {
  const money = (cents) =>
    (cents / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });

  function bindCart(root) {
    const state = {};
    const getQty = (v) => state[v] || 0;

    async function refresh() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        Object.keys(state).forEach((k) => delete state[k]);
        cart.items.forEach((i) => {
          state[i.variant_id] = i.quantity;
        });
      } catch (e) {
        /* noop */
      }
    }

    function renderCardState(cartEl, qty) {
      const label = cartEl.querySelector('.ps-card__qty-label');
      if (qty > 0) {
        cartEl.classList.add('is-in-cart');
        const unit = parseInt(cartEl.closest('.ps-card').dataset.price, 10) || 0;
        if (label) label.textContent = qty + ' in cart — ' + money(unit * qty);
      } else {
        cartEl.classList.remove('is-in-cart');
      }
    }

    async function sync() {
      await refresh();
      root.querySelectorAll('.ps-card__cart').forEach((el) => renderCardState(el, getQty(el.dataset.variantId)));
    }

    function applySections(cart, json) {
      if (!json.sections) return;
      cart.getSectionsToRender().forEach((section) => {
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const html = json.sections[section.id];
        if (!target || html == null) return;
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(section.selector || '.shopify-section');
        target.innerHTML = source ? source.innerHTML : html;
      });
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof cart.close === 'function') overlay.addEventListener('click', cart.close.bind(cart));
      const total = Object.values(state).reduce((a, b) => a + b, 0);
      cart.classList.toggle('is-empty', total === 0);
    }

    async function change(variantId, quantity, cartEl) {
      quantity = Math.max(0, quantity);
      const isAdd = getQty(variantId) === 0 && quantity > 0;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const ids = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
      const payload = { sections: ids.join(','), sections_url: window.location.pathname };
      try {
        let res;
        if (isAdd) {
          res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }], ...payload }),
          });
        } else {
          res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(variantId), quantity: quantity, ...payload }),
          });
        }
        const json = await res.json();
        await refresh();
        renderCardState(cartEl, getQty(variantId));
        if (cart && cart.getSectionsToRender) applySections(cart, json);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-related', cartData: json });
        }
      } catch (e) {
        /* noop */
      }
    }

    root.addEventListener('click', (e) => {
      const add = e.target.closest('.ps-card__add');
      const qtyBtn = e.target.closest('.ps-card__qty-btn');
      const wishlist = e.target.closest('.ps-card__wishlist');
      if (add) {
        const cell = add.closest('.ps-card__cart');
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + 1, cell);
      } else if (qtyBtn) {
        const cell = qtyBtn.closest('.ps-card__cart');
        const delta = qtyBtn.dataset.action === 'increase' ? 1 : -1;
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + delta, cell);
      } else if (wishlist) {
        toggleWishlist(wishlist);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (ev && ev.source === 'pdp-related') return;
        sync();
      });
    }

    sync();
  }

  function toggleWishlist(btn) {
    const KEY = 'destilo_wishlist';
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      list = [];
    }
    const id = btn.dataset.productHandle;
    const i = list.indexOf(id);
    if (i > -1) {
      list.splice(i, 1);
      btn.classList.remove('is-active');
    } else {
      list.push(id);
      btn.classList.add('is-active');
    }
    localStorage.setItem(KEY, JSON.stringify(list));
    /* Sube el cambio a la cuenta si hay sesión (assets/wishlist-sync.js). */
    if (window.DestiloWishlistSync) window.DestiloWishlistSync.push();
  }

  function markWishlist(root) {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem('destilo_wishlist')) || [];
    } catch (e) {
      list = [];
    }
    root.querySelectorAll('.ps-card__wishlist').forEach((b) =>
      b.classList.toggle('is-active', list.includes(b.dataset.productHandle))
    );
  }

  // Oculta la sección Y su wrapper .shopify-section para que no quede hueco
  // en blanco cuando no hay recomendaciones.
  function hideSection(section) {
    section.hidden = true;
    const wrap = section.closest('.shopify-section') || section;
    wrap.style.display = 'none';
  }

  async function initSection(section) {
    const grid = section.querySelector('[data-pdp-related-grid]');
    if (!grid) return;

    // If not already server-rendered, fetch recommendations and inject the cards.
    if (grid.children.length === 0 && section.dataset.url) {
      try {
        const html = await fetch(section.dataset.url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetched = doc.querySelector('[data-pdp-related-grid]');
        if (fetched && fetched.children.length) {
          grid.innerHTML = fetched.innerHTML;
        } else {
          hideSection(section);
          return;
        }
      } catch (e) {
        hideSection(section);
        return;
      }
    } else if (grid.children.length === 0) {
      // Sin URL y sin contenido: nada que mostrar.
      hideSection(section);
      return;
    }

    // Las cards usan la clase .products-showcase__grid, cuyos hijos heredan el
    // estado oculto (opacity:0) del sistema de reveal. Como esta sección NO está
    // en ese sistema y las cards se inyectan por JS, las marcamos visibles.
    grid.querySelectorAll('.ps-card').forEach(function (c) { c.classList.add('da-in'); });

    bindCart(section);
    markWishlist(section);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-related]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
